import { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import SystemInfoApi from "./api";

const CommandConsole = () => {
    const [command, setCommand] = useState("");
    const [output, setOutput] = useState("");
    const [loading, setLoading] = useState(false);

    // ✅ Track current working directory
    const [cwd, setCwd] = useState("/");

    const runCommand = async () => {
        if (!command.trim()) return;

        // Handle `cd` locally
        if (command.trim().startsWith("cd")) {
            const parts = command.trim().split(" ");
            const newPath = parts[1] || "/";

            setCwd(newPath);
            setOutput(`Changed directory to ${newPath}`);
            setCommand("");
            return;
        }

        setLoading(true);
        setOutput("");

        try {
            const res = await SystemInfoApi.runCommand({
                command: command.trim(),
                cwd, // 👈 send current directory
            });

            setOutput(res.data.output || "(no output)");
        } catch (err) {
            setOutput("❌ Command execution failed");
        } finally {
            setLoading(false);
            setCommand("");
        }
    };

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="h6">Command Console</Typography>

            {/* Fake terminal prompt */}
            <Typography
                sx={{
                    fontFamily: "monospace",
                    color: "#0f0",
                    bgcolor: "#000",
                    px: 1,
                    py: 0.5,
                    borderRadius: "4px",
                    display: "inline-block",
                }}
            >
                {cwd} $
            </Typography>

            <TextField
                fullWidth
                label="Command"
                value={command}
                onChange={(e) => setCommand(e.target.value)}
                placeholder="ls"
                sx={{ my: 2 }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") runCommand();
                }}
            />

            <Button
                variant="contained"
                onClick={runCommand}
                disabled={loading}
            >
                Run
            </Button>

            <Box
                sx={{
                    mt: 3,
                    p: 2,
                    bgcolor: "#000",
                    color: "#00ff00",
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    minHeight: "250px",
                    borderRadius: "4px",
                    overflowY: "auto",
                }}
            >
                {output || "Output will appear here..."}
            </Box>
        </Box>
    );
};

export default CommandConsole;
